/**
 * @returns Locally unique id
 *
 * crypto.randomUUID returns a uuid v4.
 */
export const getId = (): string => crypto.randomUUID();
